import { ArrowBack, CopyAllOutlined } from "@mui/icons-material";
import { Box, Grid, IconButton, InputAdornment } from "@mui/material";
import { useState } from "react";
import {
  Button,
  CheckboxGroupInput,
  Edit,
  EditButton,
  required,
  SelectInput,
  SimpleForm,
  SimpleShowLayout,
  TextField,
  TextInput,
  Toolbar,
  TopToolbar,
  useRecordContext,
} from "react-admin";
import { useFormContext } from "react-hook-form";
import sendRequest from "../../dataProvider/sendRequest";
import CustomButtonCancel from "../../unit/CustomButtonCancel";
import CustomButtonSave from "../../unit/CustomButtonSave";
import HmTextInput from "../../unit/HmTextInput";
import useNotify from "../../unit/useNotify";
import React from "react";

const EditToolbar = (props: any) => {
  const { reset } = useFormContext();
  const { success, error, info } = useNotify();
  const { getValues, formState } = useFormContext();
  const isDirty = formState.isDirty;

  const record = useRecordContext();
  const id = record?.id;
  const handleUndo = () => {
    reset();
    //set isDirty to false
    success("Changes have been cancel");
  };

  const saveData = () => {
    const reqUrl = "banks/actions/edit";

    const formData = isDirty ? getValues() : null;
    if (formData) {
      if (!formData.sLanguage || !formData.sLanguage.includes("en")) {
        error("English is required in Language Settings");
        return;
      }
      const saveFormData = {
        language_settings: formData.sLanguage,
        saveType: "language",
      };

      sendRequest(reqUrl, { id: id, data: saveFormData }).then((res) => {
        if (res?.code == 200) {
          success("Saved successfully");
          reset(formData);
        } else {
          error("Error saving " + res?.message);
        }
      });
    } else {
      error("Error saving description: No data to save");
    }
  };
  return (
    <Box
      sx={{
        display: "block",
        mt: "2px",
        borderRadius: "0px",
        paddingTop: "0px",
      }}
    >
      <Toolbar
        {...props}
        sx={{
          background: "#fff",
          justifyContent: "space-between",
          // border: "1px solid red",
          borderTop: "1px solid #e0e0e0",
          padding: "0px",
          marginTop: "10px",
          "&.MuiToolbar-root.RaToolbar-root": {
            paddingLeft: "0px",
            paddingRight: "0px",
          },
        }}
      >
        <CustomButtonCancel label="Undo" onClick={handleUndo} />
        {/* <SaveButton /> */}
        <CustomButtonSave
          variant="contained"
          color="primary"
          onClick={saveData}
          disabled={!isDirty}
          sx={{
            width: "120px",
          }}
        />
      </Toolbar>
    </Box>
  );
};

const LanguageEditForm = ({ isEdit = false, admin = false }) => {
  const record = useRecordContext();

  if (!record) return <div>Loading...</div>;
  const CustomLanguageSettings = () => {
    const record = useRecordContext();

    return (
      <CheckboxGroupInput
        source="sLanguage"
        label="Language Settings"
        defaultValue={record?.sLanguage || ["en"]}
        readOnly={isEdit ? false : true}
        row={false}
        fullWidth
        validate={[
          (value) => {
            if (value?.includes("en")) {
              return undefined;
            }
            return "English is required";
          },
        ]}
        choices={[
          { id: "en", name: "English", value: "en", required: true },
          { id: "es", name: "Spanish", value: "es" },
          { id: "ps", name: "Pashto", value: "ps" },
        ]}
        variant="outlined"
      />
    );
  };
  return (
    <SimpleForm toolbar={<EditToolbar />}>
      <Box
        sx={{
          pt: 1,
          pb: 1,
          width: "100%",
          // backgroundColor: "#fff",
          height: `calc(100vh - 387px)`,
          minHeight: `calc(100vh - 387px)`,
          overflowY: "auto",
        }}
        className="bank_profile_info"
        id="bank_edit_profile_info"
      >
        <CustomLanguageSettings />
      </Box>
    </SimpleForm>
  );
};

const LanguageEdit = () => {
  const [isEditing, setIsEditing] = useState(false);
  const { success, error, info } = useNotify();

  const Actions = () => (
    <TopToolbar>
      {!isEditing ? (
        <EditButton
          onClick={() => setIsEditing(true)}
          sx={{ width: "100px" }}
        />
      ) : (
        <Button
          label="Back"
          onClick={() => {
            setIsEditing(false);
          }}
          sx={{ width: "100px" }}
          startIcon={<ArrowBack />}
        />
      )}
    </TopToolbar>
  );

  const handleSuccess = () => {
    setIsEditing(false);
    success("updated successfully");
  };
  const admin = localStorage.getItem("authrole") == "admin" ? true : false;
  return (
    <Edit
      title="Welcome"
      actions={<Actions />}
      mutationOptions={{ onSuccess: handleSuccess }}
    >
      {<LanguageEditForm isEdit={isEditing} admin={admin} />}
    </Edit>
  );
};

export default LanguageEdit;
